import { motion } from "motion/react";
import heroVideo from "../Assets/wef1-2027-back.webm";
import aladinLogo from "../Assets/wef-aladin-logo.png";
import './mainbanner.css';

const lanterns = Array.from({ length: 18 });
const sparks = Array.from({ length: 36 });

const MainBanner = () => {
  return (
    <section id="home" className="hero">
      <div className="hero-bg">
        <video
          className="hero-bg-video"
          src={heroVideo}
          autoPlay
          muted
          playsInline
          preload="auto"
          aria-label="World Education Festival background"
        />
        <div className="hero-bg-gradient" />
      </div>

      <div className="hero-effects" aria-hidden="true">
        {lanterns.map((_, i) => (
          <span
            key={i}
            className="hero-lantern"
            style={{
              left: `${(i * 7.3) % 100}%`,
              bottom: "-40px",
              width: `${8 + (i % 4) * 3}px`,
              height: `${12 + (i % 4) * 4}px`,
              animationDelay: `${(i * 1.7) % 12}s`,
              animationDuration: `${16 + (i % 5) * 3}s`,
            }}
          />
        ))}

        {sparks.map((_, i) => (
          <span
            key={`s${i}`}
            className="hero-spark"
            style={{
              left: `${(i * 13.7) % 100}%`,
              top: `${(i * 7.3) % 90}%`,
              animationDelay: `${(i % 10) * 0.4}s`,
            }}
          />
        ))}
      </div>

      <div className="hero-content">
        <motion.div
          initial={{ opacity: 0, y: 30, scale: 0.95 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
          className="hero-title"
        >
          <img src={aladinLogo} alt="World Education Festival" className="img-fluid main-logo" />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.45 }}
          className="coming-soon-sign"
        >
          See You in September
        </motion.div>
      </div>

      <div className="text-center">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.5 }}
          className="hero-subtitle"
        >
          A magical study-abroad festival experience is being prepared.
        </motion.p>
      </div>
    </section>
  );
};

export default MainBanner;
